<div class="component__creditNumber resumeButton">
  <div class="component__creditNumberContent">
    <button pButton pRipple iconPos="right" class="p-button-secondary p-button-raised p-button-rounded n-background n-shadow white small mIconBig" (click)="onResumeCredit()">
      <div class="p-button-label">{{ 'N° del crédito:' | termReplace }} <strong>{{creditNumber?.toUpperCase()}}</strong></div>
      <span class="p-button-icon pi pi-angle-down ml-6"></span>
    </button>
  </div>
</div>


<!--CREDIT RESUME MODAL-->
<p-dialog [(visible)]="visibleCreditResume" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>{{ 'Resumen del crédito' | termReplace }}</h2>
          <p>N° de cliente: <strong>{{data?.person.number.toUpperCase()}}</strong></p>
          <p>{{ 'N° del crédito:' | termReplace }} <strong>{{creditNumber?.toUpperCase()}}</strong></p>
        </div>
        <ng-container *ngIf="data?.product?.code !== null">

          <!-- RESUMEN GENERAL -->
          <ng-container *ngIf="!isTopUpLoan">
          <div class="dialog__block pt-40">
            <div class="clientBox pb-25">
                <div class="icon">
                  <app-circle-client-icon></app-circle-client-icon>
                </div>
                <div class="info">
                  <p><strong>Cliente:</strong> {{ data?.person?.first_name  }} {{ data?.person?.last_name }}</p>
                  <p><strong>Documento:</strong> {{  data?.person?.document_id_number }}</p>
                </div>
              </div>

            <div class="resumeBox">
              <div class="product mb-20">
                <div class="subtitle mb-10">
                  <h2>Producto seleccionado</h2>
                </div>

                <div class="product__item">
                  <div class="productListItem__cont productListItem__cont--modal">
                    <div class="img">
                      <img src="assets/images/icon-telefono.svg" alt="Redmi Note 12 Pro+ 5G 256gb 8 RAM">
                    </div>
                    <div class="info">
                      <div class="title">
                        <h3>{{ data?.product?.name }}</h3>
                      </div>
                      <div class="main-price" *ngIf="!macroFlowService.isExperanzaFlow(this.flowCode)">
                        <p>{{ getMainProductAmount() | currency }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="additionalProductSummary mb-15" *ngIf="hasAdditionalProduct()">
                <div class="separator">
                  <i>
                    <app-circle-full-plus-icon></app-circle-full-plus-icon>
                  </i>
                </div>

                <div class="subtitle mb-10">
                  <h2>Producto adicional</h2>
                </div>

                <div class="additionalProductSummary__item mb-15">
                  <div class="additionalProductSummary__itemCont">
                    <div class="category">
                      <span>{{ getAdditionalProduct()?.category }}</span>
                      </div>

                    <div class="info">
                      <h3>{{ getAdditionalProduct()?.name }}</h3>
                      <span>{{ getAdditionalProductNetAmount() | currency}}</span>
                    </div>

                    <div class="details">
                      <p><span>Monto: <strong>{{ getAdditionalProduct()?.amount | currency}}</strong></span> <span class="circle"></span> <span>Descuento: <strong>{{ getAdditionalProduct()?.discount_pct }}%</strong></span></p>
                  </div>
                </div>
              </div>

                <div class="additionalProductSummary__breakdown">
                  <div class="title">
                    <i>
                      <app-money-white-icon></app-money-white-icon>
                    </i>
                    <h3>Detalle del crédito</h3>
                  </div>

                  <div class="summary">
                    <ul>
                      <li>
                        <span class="text">Subtotal productos</span>
                        <span class="value">{{ getProductsSubtotal() | currency}}</span>
                      </li>
                      <li>
                        <span class="text">Abono</span>
                        <span class="value">- {{ getInstallmentAmount() | currency}}</span>
                      </li>
                      <li class="highlight">
                        <span class="text">Monto financiado total</span>
                        <span class="value">{{ getFinancedTotalAmount() | currency}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="pricingBox__financed mb-20" *ngIf="!hasAdditionalProduct()">
                <div class="pricingBox__financedTitle">
                  <i>
                    <app-money-white-icon></app-money-white-icon>
                  </i>
                  <h4>Monto financiado:</h4>
                </div>
                <div class="pricingBox__financedValue">
                  <p><strong>{{ calculateFinancedAmount() | currency }}</strong></p>
                </div>
              </div>

              <div class="credit">
                <p>Abono de <strong>{{ data?.quotes?.installment?.selected | currency }}</strong> y pago de <strong>{{ data?.quotes?.quota?.selected | currency }} {{frequencyText()}}</strong> durante <strong>{{ data?.quotes?.quota.quantity }} cuotas</strong>.</p>
              </div>
            </div>
            </div>
          </ng-container>

          <!-- RESUMEN RETANQUEO -->
          <ng-container *ngIf="isTopUpLoan">
            <div class="dialog__block pt-40">
              <div class="clientBox">
                <div class="icon">
                  <app-circle-client-icon></app-circle-client-icon>
                </div>
                <div class="info">
                  <p><strong>Cliente:</strong> {{ data?.person?.first_name  }} {{ data?.person?.last_name }}</p>
                  <p><strong>Documento:</strong> {{  data?.person?.document_id_number }}</p>
                </div>
              </div>

              <div class="resumeBox mt-20">
                <div class="product product--border mb-25">
                  <div class="subtitle mb-10">
                    <h2>Producto adquirido</h2>
                  </div>

                  <div class="product__item">
                    <div class="productListItem__cont productListItem__cont--modal">
                      <div class="img">
                        <img src="assets/images/icon-telefono.svg" alt="Redmi Note 12 Pro+ 5G 256gb 8 RAM">
                      </div>
                      <div class="info">
                        <div class="title">
                          <h3>{{ data?.product?.name }}</h3>
                        </div>
                        <div class="main-price">
                          <p>{{ data?.quotes?.prices?.selected | currency }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="creditSummary mb-25">
                  <div class="creditSummary__title">
                    <h2>Resumen de consolidación</h2>
                  </div>
                  <div class="creditSummary__content">
                    <div class="creditSummary__header">
                      <i><app-hand-money-simple-icon></app-hand-money-simple-icon></i>
                      <h3>Consolidación del crédito</h3>
                    </div>

                    <div class="creditSummary__items">
                      <ul>
                        <li>
                          <div class="item__content">
                            <div div class="title">Crédito anterior</div>
                            <div class="value"><span class="highlight">+ {{ topUpLoan.current_loan.balance ?? 0 | currency }}</span></div>
                          </div>
                        </li>
                        <li>
                          <div class="item__content">
                            <div class="title">Descuento por cancelación anticipada</div>
                            <div class="value">- {{ topUpLoan.consolidation.discount | currency }}</div>
                          </div>
                        </li>
                        <li class="sub">
                          <div class="item__content">
                            <div class="title">Subtotal saldo a consolidar</div>
                            <div class="value">{{ subtotalToConsolidate | currency }}</div>
                          </div>
                        </li>
                        <li>
                          <div class="item__content">
                            <div class="title">Valor financiado — nueva compra</div>
                            <div class="value"><span class="highlight">+ {{ topUpLoan.consolidation.total_new_credit | currency }}</span></div>
                          </div>
                          <div class="item__desc">
                            <p>KrediYA pagará este valor al comercio por esta compra.</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="creditSummary__total">
                    <div class="title">Nuevo monto del crédito consolidado</div>
                    <div class="value">
                      <i><app-circle-money-icon></app-circle-money-icon></i>
                      <span>{{ topUpLoan.consolidation.total_financed | currency }}</span>
                    </div>
                  </div>
                </div>

                <div class="advancePayment mb-25" *ngIf="hasAdvancePayment">
                  <div class="advancePayment__title">
                    <h2>Anticipo pagado en tienda</h2>
                  </div>

                  <div class="advancePayment__content">
                    <div class="value">
                      <h3>Anticipo pagado por el cliente</h3>
                      <span>{{ topUpLoan.advance_payment | currency }}</span>
                    </div>

                    <div class="description">
                      <p>Este valor fue abonado por el cliente como anticipo en tienda.</p>
                    </div>
                  </div>
                </div>

                <div class="creditConditions mb-25">
                  <div class="creditConditions__title">
                    <h2>Condiciones del crédito</h2>
                  </div>

                  <div class="creditConditions__content">
                    <div class="items">
                      <div class="item">
                        <div class="item__content">
                          <div class="content">
                            <h3>Cuota {{ frequencyTextSingular(topUpLoan.new_loan.frequency) }}</h3>
                            <span class="highlight">{{ topUpLoan.new_loan.quota_amount | currency }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="item">
                        <div class="item__content">
                          <div class="content">
                            <h3>Primera cuota</h3>
                            <span>{{ topUpLoan.first_payment_date | date:'longDate' }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="item">
                        <div class="item__content">
                          <div class="content">
                            <h3>Plazo</h3>
                            <span>{{ topUpLoan.new_loan.quota_quantity }} cuotas</span>
                          </div>
                        </div>
                      </div>

                      <div class="item">
                        <div class="item__content">
                          <div class="content">
                            <h3>Frecuencia</h3>
                            <span>{{ frequencyTextSingular(topUpLoan.new_loan.frequency) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="creditInfo">
                  <div class="title">
                    <h2>Importante</h2>
                  </div>
                  <div class="msgAlert">
                    <div class="msgAlert__title">
                      <i><app-alert-simple-icon></app-alert-simple-icon></i>
                      <h3>Crédito anterior cancelado</h3>
                    </div>
                    <div class="msgAlert__description">
                      <p>El crédito anterior fue cancelado automáticamente. El cliente solo tiene este nuevo crédito consolidado activo.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </ng-container>
        <div class="dialog__btn pt-20" *ngIf="getCanCancelRequest()">
          <app-sales-cancel-request></app-sales-cancel-request>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
